import {useTranslation} from "react-i18next";
import {useFormSchema} from "../use-form-schema.hook";
import {useForm} from "react-hook-form";

export const useSignUpValidation = () => {
    const {t} = useTranslation(['common', 'auth']);

    const {provider, resolver, Controller} = useFormSchema();
    const schema = provider.object().shape({
        firstName: provider.string()
            .required(t('REQUIRED_FIELD')),
        lastName: provider.string()
            .required(t('REQUIRED_FIELD')),
        email: provider.string()
            .email(t('INVALID_EMAIL'))
            .required(t('REQUIRED_FIELD')),
        password: provider.string()
            .min(6, t('MINIMUM_LENGTH', {length: 6}))
            .required(t('REQUIRED_FIELD')),
        toc: provider.bool()
            .oneOf([true], t('auth:NEED_TO_ACCEPT_TOC'))
    });

    const form = useForm({
        resolver: resolver(schema as any)
    });

    return {
        Controller,
        ...form
    }


}
